<template>
  <div>
    <el-dialog
      title="编辑分批发货"
      :visible.sync="dialogVisible"
      width="1000px"
      top="15px"
      @open="open"
      @close="close"
    >
      <el-button type="primary" style="margin-bottom:10px" @click="deleteSelect">
        删除勾选的产品
      </el-button>

      <el-table ref="multipleTable" :data="tableData" border style="width: 100%"
                @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
        />
        <el-table-column prop="itemIndex" label="序号" align="left" fixed="left" />
        <el-table-column prop="contractNum" label="合同号" align="left" />
        <el-table-column prop="materialNumber" label="物品代码" align="left" />
        <el-table-column prop="productName" label="物品名称" align="left" />
        <el-table-column prop="productNum" label="数量" align="left" />
        <el-table-column v-if="amountDisplayFlag" prop="productPriceSigle" label="实际结算单价" align="right" header-align="left" width="160" />
        <el-table-column v-if="amountDisplayFlag" prop="settlementAmount" label="实际结算金额" align="right" header-align="left" width="160" />
        <el-table-column prop="expectedDeliveryDate" label="客户期望发货日" align="left" />
        <el-table-column prop="agreedDate" label="约定交付日期" align="left" />
      </el-table>
      <div class="footer-btn">
        <!-- <el-button type="warning" :loading="loadingBach" @click="backList">
          废弃
        </el-button> -->
        <el-button type="primary" :loading="loadingSub" @click="submit">
          提交
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { partialInvoiceProduct, rejectAppliedPartialInvoiceSubmit, partialInvoiceInvalid } from '@/API/index.js';
import { checkPartialShipmentCompliance } from '@/libs/partialShipmentCompliance';
export default {
  data () {
    return {
      dialogVisible: this.dialogVisibleExit,
      tableData: [],
      multipleSelection: [],
      loadingSub: false,
      loadingBach: false
    };
  },
  props: {
    dialogVisibleExit: {
      type: Boolean,
      default: false
    },
    id: {
      type: [String, Number],
      default: () => {
        return 0;
      }
    },
    amountDisplayFlag: {
      type: Boolean,
      default: false
    }
  },
  components: {
  },
  methods: {
    initData () {
      partialInvoiceProduct({ id: this.id }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data;
        } else {

        }
      }).catch((res) => {
      });
    },

    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    // 判断时间
    judgeTime (time) {
      if (time) {
        var strtime = time.replace('/-/g', '/');// 时间转换
        // 时间
        var date1 = new Date(strtime);
        // 现在时间
        var date2 = new Date();
        // 判断时间是大于当前时间
        return date1 > date2;
      } else {
        return true;
      }
    },
    deleteSelect () {
      let val = this.multipleSelection;
      if (val) {
        // 将选中数据遍历
        for (var j = 0; j < val.length; j++) {
          if (this.judgeTime(val[j].agreedDate)) {
            this.tableData.forEach((v, i) => {
            // 如果选中数据和源数据的某一条唯一标识符相等，删除对应的源数据
              if (val[j].id === v.id) {
                this.tableData.splice(i, 1);
              }
            });
          } else {
            this.$message.error('约定交付日期大于今天的产品才能删除');
            return;
          }
          // 遍历源数据
        }
      }
      // 清除选中状态
      this.$refs.multipleTable.clearSelection();
    },
    close () {
      this.$refs.multipleTable.clearSelection();
    },
    open () {
      this.initData();
    },
    async submit () {
      this.loadingSub = true;
      let val = this.tableData;
      let parmas = val;
      try {
        const canSubmit = await checkPartialShipmentCompliance({
          businessScene: 'DOMESTIC_PARTIAL_SHIPMENT_CHANNEL_SUBMIT',
          originalBizId: this.id,
          products: parmas
        });
        if (!canSubmit) {
          this.loadingSub = false;
          return;
        }
      } catch (error) {
        this.loadingSub = false;
        this.$message.error(error.message || '出口合规检测失败');
        return;
      }
      rejectAppliedPartialInvoiceSubmit(this.id, parmas).then((res) => {
        let json = res.data;
        this.loadingSub = false;
        if (json.status === '200') {
          this.dialogVisible = false;
          this.$emit('on-exit-fresh', 'fresh');
        } else {

        }
      }).catch((res) => {
        this.loadingSub = false;
      });
    },
    // backList () {
    //   let parmas = { id: this.id };
    //   checkSplitAndFreightPayType(parmas).then((res) => {
    //     let json = res.data;
    //     if (json.data) {
    //       this.$confirm('此单运费差价使用返利支付，废弃时此单关联的其他发货单将全部废弃', '提示', {
    //         confirmButtonText: '确定',
    //         cancelButtonText: '取消',
    //         type: 'warning'
    //       }).then(() => {
    //         this.backListT();
    //       }).catch(() => {
    //       });
    //     } else {
    //       this.backListT();
    //     }
    //   }).catch(() => {
    //     this.backListT();
    //   });
    // },
    backListT () {
      this.loadingBach = true;
      partialInvoiceInvalid({ id: this.id, processState: 6 }).then((res) => {
        let json = res.data;
        this.loadingBach = false;
        if (json.status === '200') {
          this.dialogVisible = false;
          this.$emit('on-exit-fresh', 'fresh');
        } else {

        }
      }).catch((res) => {
        this.loadingBach = false;
      });
    }

  },
  watch: {
    dialogVisibleExit (val) {
      this.dialogVisible = val;
    },
    dialogVisible (val) {
      this.$emit('on-exit-dialog', val);
    }
  },
  mounted () {

  }

};
</script>

<style scoped>
.footer-btn{
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
</style>
